/**
 * ApiHealthClient -- la salud publica de la API (GET /api/health), sin sesion.
 *
 * CONTRATO-VISTA-PANEL-T1 (familia fetch directo): SystemInfoView hacia este fetch en la vista. Es la misma peticion,
 * movida aqui: /api/health es publica, asi que no pasa por ApiBase (no lleva sesion ni reintentos). No confundir con
 * SaludApiClient (el tablero de salud del sistema, con sesion).
 *
 * @module infrastructure/api/ApiHealthClient
 */
import { AppConfig } from '../../config.js';

export const ApiHealthClient = {
  /** @returns {Promise<Response>} la respuesta tal cual (la vista decide con res.ok y res.json()); lanza si no hay red */
  leer() {
    return fetch(`${AppConfig.apiBase}/api/health`);
  }
};
